// @ts-ignore
// @ts-nocheck
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Steps } from 'intro.js-react';
import 'intro.js/introjs.css';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import { AxiosRequestConfig } from 'axios';
import { useMediaQuery } from 'react-responsive';
import GenericNavBar from 'newComponents/GenericNavBar';
import { List } from 'components/Granel/boletos/Item';
import PaginationComponent from 'components/layout/Pagination';
import ModalContent from 'components/Granel/boletos/Modal';
import ModalFilter from 'components/Granel/boletos/Filter/Modal';
import Loading from 'components/layout/loading';

import { insertScrollTop } from 'utils/scroll';
import scrollBlock from 'utils/functions/scrollBlock';
import { verifyUser } from 'utils/functions';

import api from 'services/api';

import { useTour } from 'hooks/useTour';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import BannerPromotions from 'BannerPromotions';
import SortModal from './SortModal';
import { steps, stepsMobile } from './providers';

import {
  HeaderPage,
  Title,
  ButtonsContainer,
  SortButton,
  SortIcon,
  ActionsButton,
  DropdownSeparator,
  FilterButton,
  FilterIcon,
  FilterText,
  ClearButton,
  SelectedText,
  Hr,
  Table,
  Th,
  SelectedItem,
  Thead,
  SortArrow,
  Tbody,
  ListForDownload,
  StyledModal,
  TableWrap,
} from './styles';
import FraudAlert from './FraudAlert';

const BankSlip: React.FC = (props) => {
  const [closeModal, setCloseModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [stepsEnabled, setStepsEnabled] = useState<boolean>(false);
  const [stepResponsive, setStepResponsive] = useState<boolean>(false);
  const [bankslipForDownload, setBankslipForDownload] = useState<any[]>([]);
  const [bankSlips, setBankSlips] = useState<any[]>([]);
  const [invoicesForDownload, setInvoicesForDownload] = useState<any[]>([]);
  const [payments, setPayments] = useState<any[]>([]);
  const [installments, setInstallments] = useState<any[]>([]);
  const [hasFilter, setHasFilter] = useState<boolean>(false);
  const [modalOrganization, setModalOrganization] = useState<boolean>(false);
  const [selectAllInvoices, setSelectAllInvoices] = useState<boolean>(false);
  const [modalFilter, setModalFilter] = useState<boolean>(false);
  const [orderBy, setOrderBy] = useState<string>('');
  const [modalPayment, setModalPayment] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalInstallments, setModalInstallments] = useState<any>();
  const [pageTotal, setPageTotal] = useState<number>(0);
  const [activePage, setActivePage] = useState<number>(1);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();
  const showMobileMode = useMediaQuery({ maxWidth: 768 });

  const activeModeDownload = true;

  useEffect(() => {
    setTourType('bankslip');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  // @ts-ignore
  const organizeBankSlips = useCallback(async (response) => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const filterStatus = params.get('status');
    let beginDate = params.get('begin-date');
    let endDate = params.get('end-date');
    let bankSlipsForEdited: any[] = [];

    // @ts-ignore
    response.forEach((invoice) => {
      // @ts-ignore
      invoice.installments.forEach((installment) => {
        // Filtros por Status
        if (!installment.typeableLine) return;

        if (filterStatus && beginDate === null) {
          if (filterStatus === 'Pagos' && installment.paymentStatus === 'CL') {
            bankSlipsForEdited = [
              ...bankSlipsForEdited,
              { installment, invoice },
            ];
          } else if (
            filterStatus === 'Vencido' &&
            installment.paymentStatus === 'OP'
          ) {
            const dueDate = new Date(installment.dueDate);
            dueDate.setDate(dueDate.getDate() + 1);
            const currentDate = new Date();
            if (currentDate > dueDate)
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
          } else if (
            filterStatus === 'A vencer' &&
            installment.paymentStatus === 'OP'
          ) {
            const dueDate = new Date(installment.dueDate);
            const currentDate = new Date();
            if (currentDate <= dueDate)
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
          } else if (filterStatus === 'Todos') {
            bankSlipsForEdited = [
              ...bankSlipsForEdited,
              { installment, invoice },
            ];
          }
        }

        // Filtros por data
        else if (beginDate && endDate) {
          // @ts-ignore
          beginDate = moment(beginDate);
          // @ts-ignore
          endDate = moment(endDate);
          // @ts-ignore
          const dueDate = moment(installment.dueDate);

          if (filterStatus === 'Pagos' && installment.paymentStatus === 'CL') {
            // @ts-ignore
            if (beginDate <= dueDate && endDate >= dueDate) {
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
            }
          } else if (
            filterStatus === 'Vencido' &&
            installment.paymentStatus === 'OP'
          ) {
            const currentDate = new Date();
            // @ts-ignore
            if (currentDate > dueDate) {
              // @ts-ignore
              if (beginDate <= dueDate && endDate >= dueDate) {
                bankSlipsForEdited = [
                  ...bankSlipsForEdited,
                  { installment, invoice },
                ];
              }
            }
          } else if (
            filterStatus === 'A vencer' &&
            installment.paymentStatus === 'OP'
          ) {
            // @ts-ignore
            const dueDate = new Date(installment.dueDate);
            const currentDate = new Date();
            if (currentDate <= dueDate) {
              // @ts-ignore
              if (beginDate <= dueDate && endDate >= dueDate) {
                bankSlipsForEdited = [
                  ...bankSlipsForEdited,
                  { installment, invoice },
                ];
              }
            }
          } else if (filterStatus === 'Todos') {
            // @ts-ignore
            if (beginDate <= dueDate && endDate >= dueDate) {
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
            }
          }
        } else {
          bankSlipsForEdited = [
            ...bankSlipsForEdited,
            { installment, invoice },
          ];
        }
      });
    });

    setBankSlips(bankSlipsForEdited);
  }, []);

  const requestInvoices = useCallback(
    // @ts-ignore
    (token, invoiceNumber, beginDate, endDate, status) => {
      const customerCode = localStorage.getItem(
        '@UltragazEmpresarial:customerCode'
      );
      const customerSiteCode = localStorage.getItem(
        '@UltragazEmpresarial:customerSiteCode'
      );
      const header = {
        'Content-Type': 'application/json',
        access_token: token,
      };
      const parameters = {
        method: 'POST',
        headers: header,
        params: {
          'customer-site-code': customerSiteCode,
          'customer-code': customerCode,
          'typeable-line': 'NOT_NULL',
          _expand: 'installments',
          _limit: 10,
          _offset: activePage - 1,
          _order_by: orderBy,
        },
      } as any;

      if (invoiceNumber) {
        // @ts-ignore
        parameters.params['invoice-number'] = invoiceNumber;
      }

      if (beginDate) {
        parameters.params['begin-date'] = beginDate;
      }

      if (endDate) {
        parameters.params['end-date'] = endDate;
      }

      if (status && status !== 'Todos') {
        let statusFilter;
        switch (status) {
          case 'A vencer':
            statusFilter = 'A_VENCER';
            break;
          case 'Pagos':
            statusFilter = 'PAGO';
            break;
          case 'Vencido':
            statusFilter = 'VENCIDO';
            break;

          default:
            break;
        }
        parameters.params.status = statusFilter;
      }

      api
        .get(`industrial/invoice/v1/invoices`, parameters as AxiosRequestConfig)
        .then((res) => {
          setLoading(false);
          const pageTotalResponse = res.headers['total-pages'];
          setPageTotal(pageTotalResponse);
          if (res.status === 200) {
            const response = res.data;
            if (response.length >= 1) {
              setPayments(response);
              setInstallments(response.installments);
              organizeBankSlips(response);
            }
            organizeBankSlips(response);
          }
        })
        .catch((err) => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    },
    [activePage, orderBy, organizeBankSlips]
  );

  const applyFilterAndRequestInvoices = useCallback(async () => {
    if (!closeModal && !showModal) {
      setLoading(true);
    }
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const beginDate = params.get('begin-date');
    const endDate = params.get('end-date');
    const filterStatus = params.get('status');
    const invoiceNumber = params.get('invoice-number');

    if (invoiceNumber) setHasFilter(true);
    if (beginDate && endDate) setHasFilter(true);
    if (filterStatus) setHasFilter(true);
    if (token) {
      requestInvoices(token, invoiceNumber, beginDate, endDate, filterStatus);
    } else {
      verifyUser(props);
    }
    setCloseModal(false);
  }, [props, requestInvoices, closeModal, showModal]);

  const onExit = useCallback(() => {
    setStepsEnabled(false);
    scrollBlock('#outer-container', 'body', false);
  }, [setStepsEnabled]);

  const handleSetStepResponsive = useCallback(() => {
    setStepResponsive(window.matchMedia('(max-width: 1100px)').matches);
  }, [setStepResponsive]);

  const toggleSteps = useCallback(() => {
    handleSetStepResponsive();
    setStepsEnabled((oldState) => !oldState);
    scrollBlock('#outer-container', 'body', true);
  }, [handleSetStepResponsive]);

  const clearSelectAllInvoices = useCallback(() => {
    setSelectAllInvoices(false);
    setBankslipForDownload([]);
  }, []);

  const requestDownload = useCallback(
    (method: string) => {
      setLoading(true);
      const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
      const customerCode = localStorage.getItem(
        '@UltragazEmpresarial:customerCode'
      );
      const customerSiteCode = localStorage.getItem(
        '@UltragazEmpresarial:customerSiteCode'
      );
      const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
      const header = {
        'Content-Type': 'application/json',
        access_token: token,
      };
      const parameters = {
        method: 'POST',
        responseType: 'blob',
        headers: header,
      };
      const body = {
        customerCode,
        customerSiteCode,
        deliveryMethod: method,
        bankslips: [...bankslipForDownload],
      };

      api
        .post(
          '/industrial/invoice/v1/duplicates',
          body,
          parameters as AxiosRequestConfig
        )
        .then((response) => {
          if (method === 'DOWNLOAD') {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `ultra_${body.bankslips.length}_boletos.zip`
            );
            document.body.appendChild(link);
            link.click();
            if (link.parentNode) {
              link.parentNode.removeChild(link);
            }
            toast.success('Boletos baixados. Confira sua pasta de downloads.');
          }
          if (method === 'EMAIL') {
            toast.success('Os boletos foram enviados para o seu e-mail.');
          }
          clearSelectAllInvoices();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          clearSelectAllInvoices();
          toast.error(err.message);
        });
    },
    [bankslipForDownload, clearSelectAllInvoices]
  );

  const clearFilter = useCallback(() => {
    window.location.href = '/boletos';
  }, []);

  const handleSetSelectAllInvoices = useCallback(() => {
    setSelectAllInvoices(!selectAllInvoices);
    setBankslipForDownload([]);

    if (selectAllInvoices === false) {
      const newBankSlips = bankSlips
        // @ts-ignore
        .filter((item) => {
          if (
            item.installment.status !== 'PAGO' &&
            item.invoice.accessKey !== undefined
          ) {
            return item.invoice.invoiceId !== undefined;
          }
          return null;
        })
        .map((item) => {
          return {
            invoiceId: item.invoice.invoiceId,
            installmentId: item.installment.installmentId,
          };
        });
      setBankslipForDownload(newBankSlips);
    }

    if (selectAllInvoices === true) {
      setBankslipForDownload([]);
    }
  }, [bankSlips, selectAllInvoices]);

  const handleOrganization = useCallback(
    // @ts-ignore
    (bankSlipsOrder: any[], organizationType: string) => {
      if (organizationType === 'maiorValor') {
        setOrderBy('amountOriginal DESC');
      } else if (organizationType === 'menorValor') {
        setOrderBy('amountOriginal ASC');
      } else if (organizationType === 'notaMaior') {
        setOrderBy('invoiceNumber DESC');
      } else if (organizationType === 'notaMenor') {
        setOrderBy('invoiceNumber ASC');
      } else if (organizationType === 'maiorData') {
        setOrderBy('dueDate DESC');
      } else if (organizationType === 'menorData') {
        setOrderBy('dueDate ASC');
      }

      setBankSlips(bankSlipsOrder);
      setModalOrganization(false);
    },
    []
  );

  // @ts-ignore
  const getStatus = useCallback((installment: any) => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    let status;
    dueDate.setDate(dueDate.getDate() + 1);
    if (installment.paymentStatus === 'OP') {
      if (currentDate > dueDate) status = 'Vencido';
      if (currentDate <= dueDate) status = 'A vencer';
    } else {
      status = 'Pago';
    }
    return status;
  }, []);

  // @ts-ignore
  const handleShow = useCallback((payment, installmentsChange) => {
    if (payment && installmentsChange) {
      setModalPayment(payment);
      setShowModal(true);
      setModalInstallments(installmentsChange);
    }
  }, []);

  const selectInvoicesForDownload = useCallback(
    // @ts-ignore
    (invoiceId, source, accessKey, status, installmentId) => {
      if (status !== 'PAGO' && accessKey !== undefined) {
        if (selectAllInvoices === true) {
          setSelectAllInvoices(false);
        }
        if (bankslipForDownload.find((item) => invoiceId === item.invoiceId)) {
          const bankslips = bankslipForDownload;
          const removeIndex = bankslips
            .map(function (item) {
              return item.invoiceId;
            })
            .indexOf(invoiceId);
          const newBankslips = bankslips.splice(removeIndex, 1);
          setInvoicesForDownload(newBankslips);
        } else {
          setBankslipForDownload([
            ...bankslipForDownload,
            {
              invoiceId,
              installmentId,
            },
          ]);
        }
      }
    },
    [bankslipForDownload, selectAllInvoices]
  );

  const goTop = useCallback(() => {
    const width = window.innerWidth;
    if (width <= 455) {
      insertScrollTop(220);
    } else {
      insertScrollTop(200);
    }
  }, []);

  const handleChangePage = useCallback(
    (pageNumber: number) => {
      setActivePage(pageNumber);
      goTop();
    },
    [goTop]
  );

  useEffect(() => {
    applyFilterAndRequestInvoices();
  }, [applyFilterAndRequestInvoices]);

  useEffect(() => {
    if (closeModal) {
      applyFilterAndRequestInvoices();
    }
  }, [applyFilterAndRequestInvoices, closeModal]);

  useEffect(() => {
    applyFilterAndRequestInvoices();
  }, [activePage, orderBy, applyFilterAndRequestInvoices]);

  useEffect(() => {
    if (modalInstallments?.installmentId) {
      const { installmentId } = modalInstallments;
      const [newModalValue] = bankSlips.filter(
        (bk) => bk.installment.installmentId === installmentId
      );
      setModalInstallments(newModalValue.installment);
    }
  }, [bankSlips, modalInstallments]);

  return (
    <GenericNavBar
      selected="boletos"
      withTable
      breadcrump="› Boletos"
      intro={toggleSteps}
    >
      {!loading && (
        <Steps
          enabled={stepsEnabled}
          steps={stepResponsive ? stepsMobile : steps}
          initialStep={0}
          onExit={onExit}
          options={{
            skipLabel: "<span class='mdi mdi-close'></span>",
            doneLabel: "<span class='mdi mdi-close'></span>",
            showStepNumbers: false,
            scrollToElement: false,
          }}
        />
      )}
      <HeaderPage>
        <Title>Boletos</Title>
        {activeModeDownload && (
          <>
            {bankslipForDownload.length >= 1 && (
              <span className="selected-download-message">
                <b>
                  {`Você selecionou ${bankslipForDownload.length} ${
                    bankslipForDownload.length > 1 ? 'boletos.' : 'boleto.'
                  }`}
                </b>
              </span>
            )}
          </>
        )}
        <ButtonsContainer hasFilter={hasFilter}>
          <SortButton onClick={() => setModalOrganization(true)}>
            <SortIcon className="mdi mdi-swap-vertical" />
            Ordenar
          </SortButton>
          {bankslipForDownload.length >= 1 && (
            <ActionsButton menuAlign="left" id="dropdown-mobile-order">
              <ActionsButton.Toggle id="ActionsButton">
                {activeModeDownload && bankslipForDownload.length >= 1 && (
                  <>
                    Baixar/enviar boletos
                    <span id="for-mail"> por e-mail</span>
                  </>
                )}
              </ActionsButton.Toggle>
              <ActionsButton.Menu>
                <ActionsButton.Item onClick={() => clearSelectAllInvoices()}>
                  <>
                    <span className="mdi mdi-close" />
                    Cancelar Seleção
                  </>
                </ActionsButton.Item>
                {activeModeDownload && bankslipForDownload.length >= 1 && (
                  <>
                    <DropdownSeparator />
                    <ActionsButton.Item
                      onClick={() => requestDownload('DOWNLOAD')}
                    >
                      <span className="mdi mdi-download" />
                      {`Baixar ${bankslipForDownload.length} ${
                        bankslipForDownload.length > 1 ? 'boletos' : 'boleto'
                      }`}
                    </ActionsButton.Item>
                    <DropdownSeparator />
                    <ActionsButton.Item
                      onClick={() => requestDownload('EMAIL')}
                    >
                      <span className="mdi mdi-email" />
                      {`Enviar ${bankslipForDownload.length} ${
                        bankslipForDownload.length > 1 ? 'boletos' : 'boleto'
                      } por e-mail`}
                    </ActionsButton.Item>
                  </>
                )}
              </ActionsButton.Menu>
            </ActionsButton>
          )}
          <FilterButton
            hasFilter={hasFilter}
            onClick={() => setModalFilter(true)}
          >
            <FilterIcon />
            <FilterText>Filtrar</FilterText>
          </FilterButton>
          {hasFilter ? (
            <ClearButton onClick={() => clearFilter()}>
              <SortIcon className="mdi mdi-close" />
              Limpar Filtros
            </ClearButton>
          ) : null}
        </ButtonsContainer>
      </HeaderPage>
      <Hr />
      <FraudAlert />
      <TableWrap
        showTour={showTour && tourType === 'bankslip' && tourStep === 1}
      >
        <Table className="intro-boletos">
          {activeModeDownload && (
            <>
              <SelectedItem
                id="selected-mobile"
                selectAllInvoices={selectAllInvoices}
                marginThead
                onClick={() => handleSetSelectAllInvoices()}
              />
              <span id="text-selected">Selecionar todos os boletos</span>
            </>
          )}
          <Thead id="headerTable">
            <Th style={{ display: 'flex', justifyContent: 'flex-start' }}>
              {activeModeDownload && (
                <SelectedItem
                  selectAllInvoices={selectAllInvoices}
                  marginThead
                  onClick={() => handleSetSelectAllInvoices()}
                />
              )}
              <SelectedText>
                <span>Competência</span>
              </SelectedText>
            </Th>
            <Th>
              <SelectedText>
                <span>Vencimento</span>
              </SelectedText>
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'maiorData')}
                className="mdi mdi-arrow-up ml-2"
                aria-label="Ordenar vencimento pela maior data"
              />
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'menorData')}
                className="mdi mdi-arrow-down ml-2"
                aria-label="Ordenar vencimento pela menor data"
              />
            </Th>
            <Th>
              <SelectedText>
                <span>Valor</span>
              </SelectedText>
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'maiorValor')}
                className="mdi mdi-arrow-up ml-2"
                aria-label="Ordenar valor pelo maior valor"
              />
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'menorValor')}
                className="mdi mdi-arrow-down ml-2"
                aria-label="Ordenar valor pelo menor valor"
              />
            </Th>
            <Th>
              <SelectedText>
                <span>Status</span>
              </SelectedText>
            </Th>
            <Th>
              <SelectedText>
                <span>Nº da Nota</span>
              </SelectedText>
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'notaMaior')}
                className="mdi mdi-arrow-up ml-2"
                aria-label="Ordenar Nota pelo maior número"
              />
              <SortArrow
                onClick={() => handleOrganization(bankSlips, 'notaMenor')}
                className="mdi mdi-arrow-down ml-2"
                aria-label="Ordenar Nota pelo menor número"
              />
            </Th>
            <Th>
              <SelectedText>
                <span>2ª via Boleto</span>
              </SelectedText>
            </Th>
          </Thead>
          <Tbody>
            {bankSlips.length > 0 ? (
              bankSlips.map((bankslip, index) => {
                const { invoice, installment } = bankslip;
                const { typeableLine } = installment;
                return (
                  <>
                    {typeableLine && (
                      <ListForDownload
                        isSelected={
                          bankslipForDownload
                            .map((item) => item.invoiceId)
                            .indexOf(invoice.invoiceId) >= 0 && true
                        }
                        selectAllInvoices={selectAllInvoices}
                        disponibleForDownload={
                          !!(
                            installment.paymentTypeBoleto &&
                            installment.status !== 'PAGO' &&
                            invoice.accessKey !== undefined
                          )
                        }
                      >
                        <List
                          open={() => handleShow(invoice, installment)}
                          installment={installment}
                          invoice={invoice}
                          status={getStatus(installment)}
                          selectItem={() => {
                            selectInvoicesForDownload(
                              invoice.invoiceId,
                              invoice.source,
                              invoice.accessKey,
                              installment.status,
                              installment.installmentId
                            );
                          }}
                          activeModeDownload={activeModeDownload}
                          selectedItem={
                            bankslipForDownload
                              .map((item) => item.invoiceId)
                              .indexOf(invoice.invoiceId) >= 0 && true
                          }
                          selectAllInvoices={selectAllInvoices}
                          disponibleForDownload={
                            !!(
                              installment.paymentTypeBoleto &&
                              installment.status !== 'PAGO' &&
                              invoice.accessKey !== undefined
                            )
                          }
                        />
                      </ListForDownload>
                    )}
                  </>
                );
              })
            ) : (
              <>
                {String(pageTotal) !== String(activePage) && (
                  <p style={{ marginLeft: 20, fontSize: 18 }}>
                    {loading && 'Carregando...'}
                    {!loading &&
                      hasFilter &&
                      'Você não possui boletos para esse filtro!'}
                    {!loading && !hasFilter && 'Você não possui boletos!'}
                  </p>
                )}
                {String(pageTotal) === String(activePage) && (
                  <p style={{ marginLeft: 20, fontSize: 18 }}>
                    Nenhum registro disponível!
                  </p>
                )}
              </>
            )}
          </Tbody>
        </Table>
        {showTour && tourType === 'bankslip' && tourStep === 1 && (
          <TourBalloon
            title="Boletos"
            content="Aqui você encontra todos os seus boletos e você poderá baixar, imprimir ou enviar por e-mail."
            position={{
              left: '50%',
              right: '0',
              top: '-185px',
              arrowPosition: 'bottom',
              maxWidth: 'unset',
              boxShadow: false,
              width: '492px',
              transform: 'translateX(-50%)',
            }}
          />
        )}
      </TableWrap>
      {pageTotal > 0 && (
        <PaginationComponent
          totalPages={pageTotal}
          isLoading={loading}
          selectedPage={activePage}
          onPageChange={handleChangePage}
        />
      )}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalContent
          // @ts-ignore
          close={() => {
            setShowModal(false);
            setCloseModal(true);
          }}
          payment={modalPayment}
          installment={modalInstallments}
          setCloseModal={setCloseModal}
          showMobileMode={showMobileMode}
        />
      </Modal>
      <StyledModal
        show={modalFilter}
        onHide={() => setModalFilter(false)}
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalFilter close={() => setModalFilter(false)} />
      </StyledModal>
      <Modal
        show={modalOrganization}
        onHide={() => setModalOrganization(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <SortModal
          // @ts-ignore
          close={() => setModalOrganization(false)}
          bankslips={bankSlips}
          sort={handleOrganization}
        />
      </Modal>
      {loading ? <Loading /> : null}
      <BannerPromotions />
    </GenericNavBar>
  );
};

export default BankSlip;
